var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20588 12.3175C0.872547 12.3175 0.588232 12.1975 0.352933 11.9573C0.117644 11.7173 0 11.4307 0 11.0976C0 10.7643 0.117644 10.4801 0.352933 10.2449L4.44116 6.15875L0.352933 2.0872C0.117644 1.84223 0 1.55805 0 1.23469C0 0.891715 0.117644 0.60509 0.352933 0.374812C0.588232 0.144534 0.872547 0.0293953 1.20588 0.0293953C1.5294 0.0293953 1.81371 0.142086 2.05881 0.367467L6.16175 4.4537L10.294 0.352761C10.5294 0.117587 10.8088 0 11.1324 0C11.4657 0 11.75 0.117587 11.9853 0.352761C12.2206 0.587945 12.3383 0.872122 12.3383 1.20529C12.3383 1.53846 12.2206 1.82753 11.9853 2.07251L7.88237 6.15875L11.9705 10.2303C12.2058 10.4459 12.3235 10.7349 12.3235 11.0976C12.3235 11.4307 12.2058 11.7173 11.9705 11.9573C11.7353 12.1975 11.4461 12.3175 11.103 12.3175C10.75 12.3175 10.4608 12.1999 10.2353 11.9647L6.16175 7.87853L2.10293 11.9647C1.85784 12.1999 1.55882 12.3175 1.20588 12.3175Z",
    fill: "#312E28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseB);
export default __webpack_public_path__ + "static/media/CloseB.a16686f2396398719abab47349c0d188.svg";
export { ForwardRef as ReactComponent };